module.exports = __webpack_public_path__ + "static/media/sorry.f7def4e0.gif";